import type { Ticket } from "./contracts";

export class FieldConflict extends Error {
  ticketId: string;
  fields: string[];
  local: Record<string, unknown>;
  remote: Ticket;

  constructor(
    ticketId: string,
    fields: string[],
    local: Record<string, unknown>,
    remote: Ticket,
  ) {
    super(`Ticket changed remotely: ${fields.join(", ")}`);
    this.name = "FieldConflict";
    this.ticketId = ticketId;
    this.fields = fields;
    this.local = local;
    this.remote = remote;
  }
}
